import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { WalletProvider } from './utils/walletContext';
import App from './App'; // Use App as the root component

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <WalletProvider>
        <App />
      </WalletProvider>
    </HelmetProvider>
  </React.StrictMode>
);